<div class="bet-slip slide" id="bet_slip_modal">

  <button (click)="dismiss()" class="close">
    <span class="icon icon-arrow-down"></span>
  </button>
  <div class="modal-dialog ">

    <div class="content">
      <div class="scroll fixed" scrollY="true">

        <div class="bets-list">

          <button class="btn btn-fill-primary" style="width: fit-content;padding: 7px 7px;"
            (click)="remove_all()">{{'MODALS.BET-SLIP.REMOVE_ALL' | translate}}</button>

          <!-- For Keno Game -->
          <div style="display: flex; flex-wrap: wrap;justify-content: center;">
            <div [ngClass]="{'add-margin': item.countryCode == 'KR6'}" *ngFor="let item of selectionData.eventSelections ;  index as i">

              <span 
                  [ngClass]="{'keno-yellow-button': checkKr3Color(item) == 'yellow', 'keno-red-button': checkKr3Color(item) == 'red'}" 
                  *ngIf="!isSpecialSelection(item) && item.countryCode == 'KR6'" 
                  class="numberCircle" 
                  style="display: inline-block;"
              >
                {{genarateSelectionNumber(item)}}
              </span>

            </div>

            <span  *ngIf="hasNumberSelectionsKeno()" (click)="remove_numbers()" style="" class="icon icon-close remove-numbers"></span>
          </div>

          <!-- For Lucky Loot Game -->
          <div style="display: flex; flex-wrap: wrap;justify-content: center;">
            <div [ngClass]="{'add-margin': item.countryCode == 'KR7'}" *ngFor="let item of selectionData.eventSelections ;  index as i">

              <span 
                  [ngClass]="{'red-button': checkKr3Color(item) == 'red', 'blue-button' : checkKr3Color(item) == 'blue' , 'green-button': checkKr3Color(item) == 'green', 'yellow-button' : checkKr3Color(item) == 'yellow'}" 
                  *ngIf="!isSpecialSelection(item) && item.countryCode == 'KR7'" 
                  class="numberCircle" 
                  style="display: inline-block;"
              >
                  {{genarateSelectionNumber(item)}}
              </span>

            </div>
            <span  *ngIf="hasNumberSelectionsLL()" (click)="remove_numbers()" style="" class="icon icon-close remove-numbers"></span>
          </div>

          <div [ngClass]="{'remove-spaces': (item.countryCode == 'KR6' || item.countryCode == 'KR7') && !isSpecialSelection(item), 'remove-border-top': (item.countryCode == 'KR6' || (item.countryCode == 'KR7' && !isSpecialSelection(item)))}" class="bets-item" *ngFor="let item of selectionData.eventSelections ;  index as i">
            <!-- <p style="font-size: x-large;padding:0px 10px;margin-bottom: 0;margin-right: 4px;margin-top: 4px;border:1px solid mintcream;">{{item.selectionNumber}}</p> -->
            <span 
                *ngIf="(item.countryCode == 'KR6' || item.countryCode == 'KR7') ? isSpecialSelection(item) : true" 
                [ngClass]="{
                    'red-button': checkKr3Color(item) == 'red', 'blue-button' : checkKr3Color(item) == 'blue' ,
                    'green-button': checkKr3Color(item) == 'green', 'yellow-button' : checkKr3Color(item) == 'yellow' ,
                    'black-button': checkKr3Color(item) == 'black', 'purple-button' : checkKr3Color(item) == 'purple' ,
                    'orange-button': checkKr3Color(item) == 'orange', 'white-button' : checkKr3Color(item) == 'white'
                }" 
                class="numberCircle"
            >
              {{genarateSelectionNumber(item)}}
            </span>

            <div *ngIf="(item.countryCode == 'KR6' || item.countryCode == 'KR7') ? isSpecialSelection(item) : true" class="info">
              <div style="color: white;font-size: 15px;" class="t">{{item.name}}</div>
              <div style="font-size: x-small;" class="t-small">{{item.meetingName+" "+item.eventCode}}</div>
            </div>
            <div *ngIf="(item.countryCode == 'KR6' || item.countryCode == 'KR7') ? isSpecialSelection(item) : true" class="extra d-flex">
              <!-- <button class="btn btn-tertiary odds-secondary" >1.05</button> -->
              <input *ngIf="!hide_placeInputFunction(item)" type="number" class="item-input" placeholder="W" value=" "
                onkeydown="if(event.key==='.'){event.preventDefault();}"
                [(ngModel)]="selectionData.eventSelections[i].win" (change)="input_changed($event)" />
              <input *ngIf="!hide_placeInputFunction(item)" type="number" class=" item-input"
                [placeholder]="item.isKLH? 'C':'P'" value=" " onkeydown="if(event.key==='.'){event.preventDefault();}"
                [(ngModel)]="selectionData.eventSelections[i].place" (change)="input_changed($event)" />
              <!-- <button (click)="remove_item(i)" class="btn btn-tertiary transparent">
                <span style="color: white;" class="icon icon-close"></span>
              </button> -->
              <span (click)="remove_item(i)" style="color: white;" class="icon icon-close"></span>
            </div>
          </div>

          <div>
            <p *ngIf="showMultipleOptions_double" style="margin-top: 20px; margin-bottom: 0;background: #284554;padding: 8px;">
              {{'MODALS.BET-SLIP.MULTIPLE-OPTIONS' | translate}}</p>

            <!-- show SINGLE -->
            <div *ngIf="showMultipleOptions_single">
              <div class="double" *ngIf="selectionData.eventSelections.length!=0">
                <div class="bets-item"
                  style="margin-top:2px;margin-bottom: 2px; padding: 0;border-bottom: 1px solid white;padding-bottom: 5px;">
                  <div class="info">
                    <div *ngIf="!isGamesOption(selectionData.bettingOptions[0]?.betName)" style="color:white;font-size: 15px;" class="t">{{'MODALS.BET-SLIP.SINGLE' | translate}}</div>
                    <div *ngIf="isGamesOption(selectionData.bettingOptions[0]?.betName)" style="color:white;font-size: 15px;" class="t">{{selectionData.bettingOptions[0]?.betName}}</div>
                  </div>
                  <div class="extra d-flex">
                    <p style="font-size: x-large;margin-bottom: 0;margin-right: 3px;margin-top: 4px;">
                      {{selectionData.bettingOptions[0]?.multiplier}}x</p>
                    <input type="number" class="item-input" placeholder="W"
                      onkeydown="if(event.key==='.'){event.preventDefault();}"
                      [(ngModel)]="selectionData.bettingOptions[0].win" (change)="input_changed($event)" />

                    <input *ngIf="!isGamesOption(selectionData.bettingOptions[0]?.betName)" type="number" class=" item-input"
                      [placeholder]="selectionData.bettingOptions[0].bets[0].betSelections[0].isKLH? 'C':'P'"
                      onkeydown="if(event.key==='.'){event.preventDefault();}"
                      [(ngModel)]="selectionData.bettingOptions[0].place" (change)="input_changed($event)" />

                    <span (click)="open_bet_selection(selectionData.bettingOptions[0])"
                      style="color: white;vertical-align: middle;" class="icon icon-search"></span>
                  </div>
                </div>
              </div>
            </div>

            <!-- show SINGLE -->

            <!-- show DOUBLE if more than 1 DOUBLE -->
            <div *ngIf="showMultipleOptions_double">
              <div class="double" *ngIf="doubleCount>1 ">
                <div class="bets-item"
                  style="margin-top:2px;margin-bottom: 2px; padding: 0;border-bottom: 1px solid white;padding-bottom: 5px;">
                  <div class="info">
                    <div style="color:white;font-size: 15px;" class="t">{{'MODALS.BET-SLIP.DOUBLE' | translate}}</div>
                  </div>
                  <div class="extra d-flex">
                    <p style="font-size: x-large;margin-bottom: 0;margin-right: 3px;margin-top: 4px;">{{doubleCount}}x
                    </p>
                    <input type="number" class="item-input" placeholder="W" (change)="doubleWinChanged($event)"
                      onkeydown="if(event.key==='.'){event.preventDefault();}" />
                    <input type="number" class=" item-input" placeholder="P"
                      (change)="doublePlaceChanged($event)" onkeydown="if(event.key==='.'){event.preventDefault();}" />
                    <!-- <button (click)="doubleOpenbetselection()" class="btn btn-tertiary transparent">
                  <span style="color: white;" class="icon icon-search"></span></button> -->
                    <span (click)="doubleOpenbetselection()" style="color: white;vertical-align: middle;"
                      class="icon icon-search"></span>
                  </div>
                </div>
              </div>
            </div>

            <!-- show DOUBLE if more than 1 DOUBLE -->

            <!-- show TRIBLE if more than 1 TRIBLE -->
            <div *ngIf="showMultipleOptions_double">
              <div class="double" *ngIf="trebleCount>1">
                <div class="bets-item"
                  style="margin-top:2px;margin-bottom: 2px; padding: 0;border-bottom: 1px solid white;padding-bottom: 5px;">
                  <div class="info">
                    <div style="color:white;font-size: 15px;" class="t">{{'MODALS.BET-SLIP.TREBLE' | translate}}</div>
                  </div>
                  <div class="extra d-flex">
                    <p style="font-size: x-large;margin-bottom: 0;margin-right: 3px;margin-top: 4px;">{{trebleCount}}x
                    </p>
                    <input type="number" class="item-input" placeholder="W" (change)="trebleWinChanged($event)"
                      onkeydown="if(event.key==='.'){event.preventDefault();}" />
                    <input type="number" class=" item-input" placeholder="P"
                      (change)="treblePlaceChanged($event)" onkeydown="if(event.key==='.'){event.preventDefault();}" />
                    <!-- <button (click)="trebleOpenbetselection()" class="btn btn-tertiary transparent">
                  <span style="color: white;" class="icon icon-search"></span></button> -->
                    <span (click)="trebleOpenbetselection()" style="color: white;vertical-align: middle;"
                      class="icon icon-search"></span>
                  </div>
                </div>
              </div>
              <!-- show TRIBLE if more than 1 TRIBLE -->

            </div>

            <div *ngIf="showMultipleOptions_double">
              <div class="bets-item" *ngFor="let item of selectionData.bettingOptions | slice:1 ;  index as i"
                style="margin-top:2px;margin-bottom: 2px; padding: 0;">

                <span *ngIf="item.betId>=88 && item.betId<=92" [ngClass]="{'red-button': checkKr3Color(item.bets[0].betSelections[0]) == 'red', 'blue-button' : checkKr3Color(item.bets[0].betSelections[0]) == 'blue' ,
              'green-button': checkKr3Color(item.bets[0].betSelections[0]) == 'green', 'yellow-button' : checkKr3Color(item.bets[0].betSelections[0]) == 'yellow' ,
              'black-button': checkKr3Color(item.bets[0].betSelections[0]) == 'black', 'purple-button' : checkKr3Color(item.bets[0].betSelections[0]) == 'purple' ,
              'orange-button': checkKr3Color(item.bets[0].betSelections[0]) == 'orange', 'white-button' : checkKr3Color(item.bets[0].betSelections[0]) == 'white'
               }" class="numberCircle">{{item.bets[0].betSelections[0].selectionNumber}}</span>

                <div class="info">
                  <div style="color:white;font-size: 15px;" class="t">{{item.betName}}</div>
                </div>

                <div class="extra d-flex">
                  <p style="font-size: x-large;margin-bottom: 0;margin-right: 3px;margin-top: 4px;">{{item.multiplier}}x
                  </p>
                  <!-- <button class="btn btn-tertiary odds-secondary" >1.05</button> -->
                  <input type="number" class="item-input" placeholder="W"
                    onkeydown="if(event.key==='.'){event.preventDefault();}"
                    [(ngModel)]="selectionData.bettingOptions[i+1].win" (change)="input_changed($event)" />
                  <input *ngIf="!item.bets[0].betSelections[0].isKLH && !isGamesOption(item.betName)" type="number"
                    class=" item-input" placeholder="P" onkeydown="if(event.key==='.'){event.preventDefault();}"
                    [(ngModel)]="selectionData.bettingOptions[i+1].place" (change)="input_changed($event)" />
                  <!-- <button (click)="open_bet_selection(item)" class="btn btn-tertiary transparent">
                <span style="color: white;" class="icon icon-search"></span></button> -->
                  <span (click)="open_bet_selection(item)" style="color: white;vertical-align: middle;"
                    class="icon icon-search"></span>
                </div>

              </div>
            </div>

          </div>




        </div>
        <button [disabled]="Proceed_clicked || total == 0" class="btn btn-block btn-fill-primary"
          (click)="click_proceed();">{{ 'COMMON.PROCEED' | translate
          }} ({{total}}.00 {{'COMMON.CURRENCY.LKR' | translate}}) <br>
          <span class="blanceBlock">{{'COMPONENTS.SLIDEMENU.BALANCE-CURRENCY' | translate}} {{userInfo.balance | number:
            '2.'}}</span>
        </button>

      </div>


    </div>
  </div>
</div>